import styled from "styled-components";
import { Modal } from "antd";

export const Container = styled(Modal)`
  &.ant-modal {
    padding-bottom: 0px !important;
  }
  .ant-row,
  .ant-row-flex {
    margin-bottom: 0.5rem;
  }

  label {
    display: block;
    color: #4b4b4b;
    font-size: 14px;
    font-weight: bold;
    margin-left: 1rem;
    margin-bottom: 4px;
  }
  .filterLabel {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 1rem;
    margin-bottom: 4px;
  }
  .error {
    color: #d44c4c;
  }

  .ant-select {
    width: 100%;
  }

  .ant-checkbox-wrapper {
    margin-bottom: 8px;
  }
`;

export const Title = styled.span`
  font-family: Asap;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  color: #4b4b4b;
  display: block;
  margin-bottom: 16px;
`;

export const ButtonContainer = styled.div`
  display: inline-block;

  svg {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    flex-shrink: 0;
  }

  .ant-btn {
    &:hover,
    &:focus {
      background-color: #148548 !important;
      border-color: #148548 !important;
    }
  }
`;
